import React, { useEffect, useState} from "react";

import { SelectBox } from "@/components/holders/SelectBox";
import { Switch,Label, Field } from '@headlessui/react'

const mapRights = [
    {id: 0, name: "Geen rechten"},
//    {id: 10, name: "Rechten overnemen van hoofd"},
//    {id: 20, name: "Alleen lezen"},
//    {id: 30, name: "Map bewerken"},
    {id: 40, name: "All rechten"}
];

const fileRights = [
    {id: 0, name: "Geen rechten"},
//    {id: 10, name: "Bestanden lezen"},
//    {id: 20, name: "Bestanden toevoegen"},
//    {id: 30, name: "Bestanden downloaden"},
    {id: 40, name: "Alle rechten"}
]
export function StorageRights({...props}) {
    const [selectedMapRights, setMapRights] = useState( ((props?.abilities && props?.abilities?.mapRights) ? props?.abilities?.mapRights : mapRights[0]) )

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

   const setValueCombobox= (name, selected) => {
       let {data} = props;
       
       if(name == "mapRights" && selected && selected?.id >= 0) {
           if(props?.setAbilitiesForStorage) {
               props.setAbilitiesForStorage(props.data, selected, null);
           }
       }
       if(name == "fileRights" && selected && selected?.id > 0) {
           if(props?.setAbilitiesForStorage) {
               props.setAbilitiesForStorage(props.data, null, selected);
           }
       }
       
       setMapRights(selected);
       //selectedStorageMap = selected;
};  

const onChangeAllRightsForChilds= (isOn) => {
    if(props?.setAllChildsSame) {
        props.setAllChildsSame(props.data, selectedMapRights, isOn);
    }
} 

let selectedFileRights = (props?.abilities) ? props?.abilities?.fileRights : fileRights[0];
//let selectedMapRights = ;
   return (
    <>


    <div className="space-y-10 divide-y divide-gray-900/10">

          <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="mapRights" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Map en bestandsrechten
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                    <SelectBox key={props.data.id} className="" label="" name="mapRights" data={mapRights} selected={selectedMapRights} boxfield="name" placeHolder="Selecteer een map" changeEvent={(name, val) => setValueCombobox(name,val)}/>
              </div>
            </div>
            
                <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
            
              <label htmlFor="mapRights" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Geef alle onderliggende mappen dezelfde rechten  
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">

    <Switch
      defaultChecked={ (props?.abilities?.rightsOnChild) ? props?.abilities?.rightsOnChild : false }      
        onChange={onChangeAllRightsForChilds} 
      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>                
              
            <Field className="flex items-center"> 
                <Label as="span" className="ml-3 text-sm">
                </Label>            
            </Field>   
             
              
              </div>
              </div>
           </div>

        

    </div>


    </>
    )   
}